import moment from "moment";

import { selectLessonsReportsFilter, setCampaignDateFromForLessonsReports, setCampaignDateToForLessonsReports, setCompanyEnabledForLessonsReports, setCompanyIdForLessonsReports, setGroupIdForLessonsReports, setInOutFromCompanyAccumulatedDateFromForLessonsReports, setInOutFromCompanyAccumulatedDateToForLessonsReports, setInOutFromCompanyDateFromForLessonsReports, setInOutFromCompanyDateToForLessonsReports, setUsersAgeForLessonsReports, setUsersGenderForLessonsReports } from "../../../features/reports/learning/lessons/filter";
import { selectUserReportsFilter, setCampaignDateFromForUserReports, setCampaignDateToForUserReports, setCompanyEnabledForUserReports, setCompanyIdForUserReports, setGroupIdForUserReports, setInOutFromCompanyAccumulatedDateFromForUserReports, setInOutFromCompanyAccumulatedDateToForUserReports, setInOutFromCompanyDateFromForUserReports, setInOutFromCompanyDateToForUserReports, setUsersAgeForUserReports, setUsersGenderForUserReports } from "../../../features/reports/users/filter";
import { selectTopicsReportsFilter, setCampaignDateFromForTopicsReports, setCampaignDateToForTopicsReports, setCompanyEnabledForTopicsReports, setCompanyIdForTopicsReports, setGroupIdForTopicsReports, setInOutFromCompanyAccumulatedDateFromForTopicsReports, setInOutFromCompanyAccumulatedDateToForTopicsReports, setInOutFromCompanyDateFromForTopicsReports, setInOutFromCompanyDateToForTopicsReports, setUsersAgeForTopicsReports, setUsersGenderForTopicsReports } from "../../../features/reports/learning/topics/filter";
import { selectCoursesReportsFilter, setCampaignDateFromForCoursesReports, setCampaignDateToForCoursesReports, setCompanyEnabledForCoursesReports, setCompanyIdForCoursesReports, setGroupIdForCoursesReports, setInOutFromCompanyAccumulatedDateFromForCoursesReports, setInOutFromCompanyAccumulatedDateToForCoursesReports, setInOutFromCompanyDateFromForCoursesReports, setInOutFromCompanyDateToForCoursesReports, setUsersAgeForCoursesReports, setUsersGenderForCoursesReports } from "../../../features/reports/learning/courses/filter";
import { selectKnowledgeBaseReportsFilter, setCampaignDateFromForKnowledgeBaseReports, setCampaignDateToForKnowledgeBaseReports, setCompanyEnabledForKnowledgeBaseReports, setCompanyIdForKnowledgeBaseReports, setGroupIdForKnowledgeBaseReports, setInOutFromCompanyAccumulatedDateFromForKnowledgeBaseReports, setInOutFromCompanyAccumulatedDateToForKnowledgeBaseReports, setInOutFromCompanyDateFromForKnowledgeBaseReports, setInOutFromCompanyDateToForKnowledgeBaseReports, setUsersAgeForKnowledgeBaseReports, setUsersGenderForKnowledgeBaseReports } from "../../../features/reports/knowledgeBase/filter";
import { selectCampaignsReportsFilter, setCampaignDateFromForCampaignsReports, setCampaignDateToForCampaignsReports, setCompanyEnabledForCampaignsReports, setCompanyIdForCampaignsReports, setGroupIdForCampaignsReports, setInOutFromCompanyAccumulatedDateFromForCampaignsReports, setInOutFromCompanyAccumulatedDateToForCampaignsReports, setInOutFromCompanyDateFromForCampaignsReports, setInOutFromCompanyDateToForCampaignsReports, setUsersAgeForCampaignsReports, setUsersGenderForCampaignsReports } from "../../../features/reports/Campaigns/filter";
import { selectCaseReportsFilter, setCampaignDateFromForCaseReports, setCampaignDateToForCaseReports, setCompanyEnabledForCaseReports, setCompanyIdForCaseReports, setGroupIdForCaseReports, setInOutFromCompanyAccumulatedDateFromForCaseReports, setInOutFromCompanyAccumulatedDateToForCaseReports, setInOutFromCompanyDateFromForCaseReports, setInOutFromCompanyDateToForCaseReports, setUsersAgeForCaseReports, setUsersGenderForCaseReports } from "../../../features/reports/case/filter";
import { ReportTypes } from "../MenuAndRoutes";
import { GenderEnum } from "../../../features/users/usersSlice";
import { ExtendedStatus } from "../Company/StatusSelector";
import { selectCompanyReportsFilter, setCampaignDateFromForCompanyReports, setCampaignDateToForCompanyReports, setCompanyEnabledForCompanyReports, setCompanyIdForCompanyReports, setGroupIdForCompanyReports, setInOutFromCompanyAccumulatedDateFromForCompanyReports, setInOutFromCompanyAccumulatedDateToForCompanyReports, setInOutFromCompanyDateFromForCompanyReports, setInOutFromCompanyDateToForCompanyReports, setUsersAgeForCompanyReports, setUsersGenderForCompanyReports } from "../../../features/reports/company/filter";
import { RootState } from "../../../app/store";
import { selectCompaniesAreFetching } from "../../../features/company/companySlice";
import { selectAreGroupsFetching } from "../../../features/groups/groupSlice";
import { selectUserStatsAreFetching } from "../../../features/reports/company/userStats";
import { selectUsersSessionDurationIsFetching } from "../../../features/reports/users/sessionDuration";
import { selectLessonsFulfillmentsFetching } from "../../../features/reports/learning/lessons/fulfillment";
import { selectLessonsFulfillmentsPerCompanyFetching } from "../../../features/reports/learning/lessons/fulfillmentPerCompany";
import { selectQuizResultsCountersIsFetching } from "../../../features/reports/learning/lessons/quizResultsCounters";
import { selectLessonsInTop10Fetching } from "../../../features/reports/learning/lessons/onTop10";
import { selectTopicsFulfillmentsFetching } from "../../../features/reports/learning/topics/fulfillment";
import { selectTopicsFulfillmentsPerCompanyFetching } from "../../../features/reports/learning/topics/fulfillmentPerCompany";
import { selectTestResultsCountersIsFetching } from "../../../features/reports/learning/topics/testResultsCounters";
import { selectTopicsInTop10Fetching } from "../../../features/reports/learning/topics/onTop10";
import { selectCoursesFulfillmentsFetching } from "../../../features/reports/learning/courses/fulfillment";
import { selectCoursesFulfillmentsPerCompanyFetching } from "../../../features/reports/learning/courses/fulfillmentPerCompany";
import { selectExamResultsCountersIsFetching } from "../../../features/reports/learning/courses/examResultsCounters";
import { selectCoursesInTop10Fetching } from "../../../features/reports/learning/courses/onTop10";
import { selectAreEvaluationFetching } from "../../../features/evaluation/evaluationsSlice";
import { selectAreUsersFetching } from "../../../features/users/usersSlice";
import { selectAreProgramsFetching } from "../../../features/program/programSlice";
import { selectAreLessonsFetching } from "../../../features/lesson/lessonSlice";
import { selectAreCoursesFetching } from "../../../features/courses/coursesSlice";
import { selectAreTopicsFetching } from "../../../features/topic/topicSlice";
import { selectIsContentFetching } from "../../../features/knowledgeBase/contentSlice";
import { selectAreContentCategoriesFetching } from "../../../features/contentCategory/contentCategorySlice";
import { selectKnowledgeBaseVisitsIsFetching } from "../../../features/reports/knowledgeBase/viewKnowledgeBase";
import { selectKnowledgeBaseByCompanyIsFetching } from "../../../features/reports/knowledgeBase/byCompany";
import { selectKnowledgeBaseByCategoryIsFetching } from "../../../features/reports/knowledgeBase/byCategory";
import { selectCampaignsAreFetching } from "../../../features/campaign/campaignSlice";
import { selectCampaignStatsAreFetching } from "../../../features/reports/Campaigns/stats";
import { selectCampaignsByYearAndMonthIsFetching } from "../../../features/reports/Campaigns/byYearAndMonth";
import { selectCampaignByCompanyIsFetching } from "../../../features/reports/Campaigns/byCompany";
import { selectCaseIsFetching as selectCaseByStatusIsFetching } from "../../../features/reports/case/ticketsByStatus";
import { selectCaseIsFetching as selectCaseByCategoryIsFetching } from "../../../features/reports/case/ticketsByCategory";
import { selectCaseIsFetching as selectCaseByReportTypeIsFetching } from "../../../features/reports/case/ticketsByReportType";
import { selectCaseIsFetching as selectCaseUsersByCaseIsFetching } from "../../../features/reports/case/usersByCase";
import { selectCaseIsFetching as selectCaseUsersByCaseResponseTimeIsFetching } from "../../../features/reports/case/usersByCaseResponseTime";
import { selectTopFiveIsFetching as selectCaseTopFiveIsFetching } from "../../../features/reports/case/ticketsByCompanyTopFive";
import { selectCompanyEnabledVsDisabledIsFetching } from "../../../features/reports/company/enabledVsDisabled";
import { selectCompanyTypesAreFetching } from "../../../features/companyType/companyTypeSlice";
import { selectChurnedDataIsFetching } from "../../../features/reports/company/insAndOutsForChurned";

const selectIsFetchingForLearningReports = (state: RootState) =>
  selectAreEvaluationFetching(state) ||
  selectAreUsersFetching(state) ||
  selectAreProgramsFetching(state) ||
  selectAreLessonsFetching(state) ||
  selectAreCoursesFetching(state) ||
  selectAreTopicsFetching(state) ||
  selectCompaniesAreFetching(state) ||
  selectAreGroupsFetching(state);

export enum AgeGroupsEnum {
  young = "young",
  youngAdult = "youngAdult",
  adult = "adult",
  mature = "mature",
}

export interface IFilterForReports {
  companyId?: string;
  companyEnabled?: ExtendedStatus;
  groupId?: string;
  campaignDates?: {
    from: moment.Moment | null;
    to: moment.Moment | null;
  };
  inOutFromCompanyDates?: {
    from: moment.Moment | null;
    to: moment.Moment | null;
  };
  inOutFromCompanyAccumulatedDates?: {
    from: moment.Moment | null;
    to: moment.Moment | null;
  };
  usersGender?: GenderEnum;
  usersAge?: AgeGroupsEnum;
}

export const getSelectorsAndSetters = (reportType?: ReportTypes) => {
  switch (reportType) {
    case ReportTypes.Users:
      return {
        setCampaignDateFrom: setCampaignDateFromForUserReports,
        setCampaignDateTo: setCampaignDateToForUserReports,
        setCompanyEnabled: setCompanyEnabledForUserReports,
        setCompanyId: setCompanyIdForUserReports,
        setGroupId: setGroupIdForUserReports,
        setInOutFromCompanyDateFrom: setInOutFromCompanyDateFromForUserReports,
        setInOutFromCompanyDateTo: setInOutFromCompanyDateToForUserReports,
        setInOutFromCompanyAccumulatedDateFrom: setInOutFromCompanyAccumulatedDateFromForUserReports,
        setInOutFromCompanyAccumulatedDateTo: setInOutFromCompanyAccumulatedDateToForUserReports,
        setUsersGender: setUsersGenderForUserReports,
        setUsersAge: setUsersAgeForUserReports,
        selectFilter: selectUserReportsFilter,
        selectIsFetching: (state: RootState) =>
          selectCompaniesAreFetching(state) ||
          selectUsersSessionDurationIsFetching(state) ||
          selectAreGroupsFetching(state) ||
          selectUserStatsAreFetching(state),
      };
    case ReportTypes.Lessons:
      return {
        setCampaignDateFrom: setCampaignDateFromForLessonsReports,
        setCampaignDateTo: setCampaignDateToForLessonsReports,
        setCompanyEnabled: setCompanyEnabledForLessonsReports,
        setCompanyId: setCompanyIdForLessonsReports,
        setGroupId: setGroupIdForLessonsReports,
        setInOutFromCompanyDateFrom: setInOutFromCompanyDateFromForLessonsReports,
        setInOutFromCompanyDateTo: setInOutFromCompanyDateToForLessonsReports,
        setInOutFromCompanyAccumulatedDateFrom: setInOutFromCompanyAccumulatedDateFromForLessonsReports,
        setInOutFromCompanyAccumulatedDateTo: setInOutFromCompanyAccumulatedDateToForLessonsReports,
        setUsersGender: setUsersGenderForLessonsReports,
        setUsersAge: setUsersAgeForLessonsReports,
        selectFilter: selectLessonsReportsFilter,
        selectIsFetching: (state: RootState) =>
          selectIsFetchingForLearningReports(state) ||
          selectLessonsFulfillmentsFetching(state) ||
          selectLessonsFulfillmentsPerCompanyFetching(state) ||
          selectQuizResultsCountersIsFetching(state) ||
          selectLessonsInTop10Fetching(state),
      }
    case ReportTypes.Topics:
      return {
        setCampaignDateFrom: setCampaignDateFromForTopicsReports,
        setCampaignDateTo: setCampaignDateToForTopicsReports,
        setCompanyEnabled: setCompanyEnabledForTopicsReports,
        setCompanyId: setCompanyIdForTopicsReports,
        setGroupId: setGroupIdForTopicsReports,
        setInOutFromCompanyDateFrom: setInOutFromCompanyDateFromForTopicsReports,
        setInOutFromCompanyDateTo: setInOutFromCompanyDateToForTopicsReports,
        setInOutFromCompanyAccumulatedDateFrom: setInOutFromCompanyAccumulatedDateFromForTopicsReports,
        setInOutFromCompanyAccumulatedDateTo: setInOutFromCompanyAccumulatedDateToForTopicsReports,
        setUsersGender: setUsersGenderForTopicsReports,
        setUsersAge: setUsersAgeForTopicsReports,
        selectFilter: selectTopicsReportsFilter,
        selectIsFetching: (state: RootState) =>
          selectIsFetchingForLearningReports(state) ||
          selectTopicsFulfillmentsFetching(state) ||
          selectTopicsFulfillmentsPerCompanyFetching(state) ||
          selectTestResultsCountersIsFetching(state) ||
          selectTopicsInTop10Fetching(state),
      }
    case ReportTypes.Courses:
      return {
        setCampaignDateFrom: setCampaignDateFromForCoursesReports,
        setCampaignDateTo: setCampaignDateToForCoursesReports,
        setCompanyEnabled: setCompanyEnabledForCoursesReports,
        setCompanyId: setCompanyIdForCoursesReports,
        setGroupId: setGroupIdForCoursesReports,
        setInOutFromCompanyDateFrom: setInOutFromCompanyDateFromForCoursesReports,
        setInOutFromCompanyDateTo: setInOutFromCompanyDateToForCoursesReports,
        setInOutFromCompanyAccumulatedDateFrom: setInOutFromCompanyAccumulatedDateFromForCoursesReports,
        setInOutFromCompanyAccumulatedDateTo: setInOutFromCompanyAccumulatedDateToForCoursesReports,
        setUsersGender: setUsersGenderForCoursesReports,
        setUsersAge: setUsersAgeForCoursesReports,
        selectFilter: selectCoursesReportsFilter,
        selectIsFetching: (state: RootState) =>
          selectIsFetchingForLearningReports(state) ||
          selectCoursesFulfillmentsFetching(state) ||
          selectCoursesFulfillmentsPerCompanyFetching(state) ||
          selectExamResultsCountersIsFetching(state) ||
          selectCoursesInTop10Fetching(state),
      }
    case ReportTypes.KnowledgeBase:
      return {
        setCampaignDateFrom: setCampaignDateFromForKnowledgeBaseReports,
        setCampaignDateTo: setCampaignDateToForKnowledgeBaseReports,
        setCompanyEnabled: setCompanyEnabledForKnowledgeBaseReports,
        setCompanyId: setCompanyIdForKnowledgeBaseReports,
        setGroupId: setGroupIdForKnowledgeBaseReports,
        setInOutFromCompanyDateFrom: setInOutFromCompanyDateFromForKnowledgeBaseReports,
        setInOutFromCompanyDateTo: setInOutFromCompanyDateToForKnowledgeBaseReports,
        setInOutFromCompanyAccumulatedDateFrom: setInOutFromCompanyAccumulatedDateFromForKnowledgeBaseReports,
        setInOutFromCompanyAccumulatedDateTo: setInOutFromCompanyAccumulatedDateToForKnowledgeBaseReports,
        setUsersGender: setUsersGenderForKnowledgeBaseReports,
        setUsersAge: setUsersAgeForKnowledgeBaseReports,
        selectFilter: selectKnowledgeBaseReportsFilter,
        selectIsFetching: (state: RootState) =>
          selectIsContentFetching(state) ||
          selectAreContentCategoriesFetching(state) ||
          selectCompaniesAreFetching(state) ||
          selectKnowledgeBaseVisitsIsFetching(state) ||
          selectAreUsersFetching(state) ||
          selectKnowledgeBaseByCompanyIsFetching(state) ||
          selectKnowledgeBaseByCategoryIsFetching(state),
      }
    case ReportTypes.Campaigns:
      return {
        setCampaignDateFrom: setCampaignDateFromForCampaignsReports,
        setCampaignDateTo: setCampaignDateToForCampaignsReports,
        setCompanyEnabled: setCompanyEnabledForCampaignsReports,
        setCompanyId: setCompanyIdForCampaignsReports,
        setGroupId: setGroupIdForCampaignsReports,
        setInOutFromCompanyDateFrom: setInOutFromCompanyDateFromForCampaignsReports,
        setInOutFromCompanyDateTo: setInOutFromCompanyDateToForCampaignsReports,
        setInOutFromCompanyAccumulatedDateFrom: setInOutFromCompanyAccumulatedDateFromForCampaignsReports,
        setInOutFromCompanyAccumulatedDateTo: setInOutFromCompanyAccumulatedDateToForCampaignsReports,
        setUsersGender: setUsersGenderForCampaignsReports,
        setUsersAge: setUsersAgeForCampaignsReports,
        selectFilter: selectCampaignsReportsFilter,
        selectIsFetching: (state: RootState) =>
          selectCampaignsAreFetching(state) ||
          selectCampaignStatsAreFetching(state) ||
          selectCampaignsByYearAndMonthIsFetching(state) ||
          selectCampaignByCompanyIsFetching(state) ||
          selectCompaniesAreFetching(state),
      }
    case ReportTypes.Cases:
      return {
        setCampaignDateFrom: setCampaignDateFromForCaseReports,
        setCampaignDateTo: setCampaignDateToForCaseReports,
        setCompanyEnabled: setCompanyEnabledForCaseReports,
        setCompanyId: setCompanyIdForCaseReports,
        setGroupId: setGroupIdForCaseReports,
        setInOutFromCompanyDateFrom: setInOutFromCompanyDateFromForCaseReports,
        setInOutFromCompanyDateTo: setInOutFromCompanyDateToForCaseReports,
        setInOutFromCompanyAccumulatedDateFrom: setInOutFromCompanyAccumulatedDateFromForCaseReports,
        setInOutFromCompanyAccumulatedDateTo: setInOutFromCompanyAccumulatedDateToForCaseReports,
        setUsersGender: setUsersGenderForCaseReports,
        setUsersAge: setUsersAgeForCaseReports,
        selectFilter: selectCaseReportsFilter,
        selectIsFetching: (state: RootState) =>
          selectCaseByStatusIsFetching(state) ||
          selectCaseByCategoryIsFetching(state) ||
          selectCaseByReportTypeIsFetching(state) ||
          selectCaseUsersByCaseIsFetching(state) ||
          selectCaseUsersByCaseResponseTimeIsFetching(state) ||
          selectCaseTopFiveIsFetching(state),
      }
    case ReportTypes.Companies:
      return {
        setCampaignDateFrom: setCampaignDateFromForCompanyReports,
        setCampaignDateTo: setCampaignDateToForCompanyReports,
        setCompanyEnabled: setCompanyEnabledForCompanyReports,
        setCompanyId: setCompanyIdForCompanyReports,
        setGroupId: setGroupIdForCompanyReports,
        setInOutFromCompanyDateFrom: setInOutFromCompanyDateFromForCompanyReports,
        setInOutFromCompanyDateTo: setInOutFromCompanyDateToForCompanyReports,
        setInOutFromCompanyAccumulatedDateFrom: setInOutFromCompanyAccumulatedDateFromForCompanyReports,
        setInOutFromCompanyAccumulatedDateTo: setInOutFromCompanyAccumulatedDateToForCompanyReports,
        setUsersGender: setUsersGenderForCompanyReports,
        setUsersAge: setUsersAgeForCompanyReports,
        selectFilter: selectCompanyReportsFilter,
        selectIsFetching: (state: RootState) =>
          selectCompanyEnabledVsDisabledIsFetching(state) ||
          selectCompaniesAreFetching(state) ||
          selectUsersSessionDurationIsFetching(state) ||
          selectCompanyTypesAreFetching(state) ||
          selectChurnedDataIsFetching(state),
      }
  }
}